import React from 'react';

import { css, cx } from '@emotion/css';

import { Tooltip } from 'components/Tooltip';

export function EllipsisTruncatedLabel({ maxWidth, label }: { maxWidth: string; label: string }) {
  // avoid creating tooltip if label fits within maxWidth characters
  if (maxWidth.endsWith('ch')) {
    const maxChars = parseInt(maxWidth.slice(0, -2), 10);
    if (label.length <= maxChars) {
      return <>{label}</>;
    }
  }

  return (
    <Tooltip title={label}>
      <div
        className={css`
          max-width: ${maxWidth};
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        `}
      >
        {label}
      </div>
    </Tooltip>
  );
}

/** for large text tooltips that need to be shown in scrollable tooltip */
export function EllipsisTruncatedScrollableTooltip({ maxChars, label }: { maxChars: number; label: string }) {
  return (
    <Tooltip
      title={
        <div
          className={css`
            white-space: pre-wrap;
            max-height: 400px;
            overflow: auto;
          `}
        >
          {label}
        </div>
      }
    >
      <div>{label.substring(0, maxChars)}…</div>
    </Tooltip>
  );
}

export function EllipsisTruncatedParagraph({
  maxLength,
  maxLines,
  label,
  className,
}: {
  maxLength: number;
  maxLines: number;
  label: string;
  className?: string;
}) {
  if (label.length <= maxLength) {
    return (
      <div
        className={cx(
          css`
            font-size: 12px;
            line-height: 18px;
          `,
          className,
        )}
      >
        {label}
      </div>
    );
  }

  return (
    <Tooltip title={label}>
      <div
        className={cx(
          css`
            font-size: 12px;
            line-height: 18px;
            max-height: ${18 * maxLines}px;
            overflow: hidden;
          `,
          className,
        )}
      >
        <div>{label.substring(0, maxLength)}…</div>
      </div>
    </Tooltip>
  );
}

/** for large text table cells that need to be truncated */
export function EllipsisTruncatedCell({ maxChars, label }: { maxChars: number; label: string }) {
  return <span>{label.substring(0, maxChars)}…</span>;
}
